import { Component, OnInit, Input } from '@angular/core';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DataService } from '../../services/data/data.service';
import { AccountService } from '../../services/account/account.service';
import { ConfigService } from '../../services/config/config.service';
import { HelpService } from '../../services/help/help.service';
import _ from 'lodash';

@Component({
	selector: 'pcm-timesheet-row-searchable',
	templateUrl: './timesheet-row-searchable.component.html',
	styleUrls: ['./timesheet-row-searchable.component.scss']
})
export class TimesheetRowSearchableComponent implements OnInit {

	@Input() hours;
	@Input() showHeadings = false;
	@Input() showTooltips = false;
	@Input() rowIndex = -1;
	@Input() correctRow = false;
	@Input() postProcessing = false;
	@Input() ilcenabled = false;
	rowAccount = {};
	rowType = '';
	canEditCustomType = false;
	defaultOptions = [];
	tooltips = {};

	constructor(
		public timesheetService: TimesheetService,
		public dataService: DataService,
		private accountService: AccountService,
		public configService: ConfigService,
		private helpService: HelpService
	) {
		this.tooltips = this.helpService.timesheet_row_tooltips;
	}

	ngOnInit() {
		if (!this.ilcenabled) {
			this.defaultOptions = this.configService.defaultOptions;
		} else {
			this.defaultOptions = [];
		}
		console.log('TIMESHEET ROW INIT HOURS', this.hours);
		this.rowAccount = this.hours[0].account;

		// if row has no ILC accounts attached and contractor is NON ILC then use hours key
		if (this.rowAccount['accountid'] === '' && !this.dataService.contractorDetails[this.configService.contractorILCProp]) {
			this.rowAccount['accountid'] = this.hours[0].key;
		}

		this.rowType = this.hours[0].type;
		if (this.rowType === '') {
			this.rowType = this.dataService.quantityTypes[0].type;
			console.log('TIMESHEET ROW TYPE DEFAULTED', this.rowType);
		}
		this.canEditCustomType = this.configService.canEditCustomTimesheetLineItem(this.rowType);
		this.updateAllAccounts();
		console.log('ROW INIT', this.hours, this.rowAccount);
	}

	checkValidRows() {
		if (this.correctRow) {
			this.timesheetService.checkValidCorrectRows();
		} else {
			this.timesheetService.checkValidRows();
		}
	}

	getHourMin() {
		let hourMin = 0;
		if (this.correctRow) {
			if (this.rowIndex <= this.dataService.timesheetRows.length - 1) {
				hourMin = -24;
			}
		}

		return hourMin;
	}

	hourChange(hour, index, correctRow, rowIndex) {

		console.log('HOUR CHANGE', hour, index, correctRow, rowIndex);
		this.timesheetService.hourChange(hour, index, correctRow, rowIndex);
	}

	hasOption(id, options, checkString) {
		let hasAccount = false;
		if (options && options.length > 0) {
			options.forEach(function (d, i) {
				if (d['checkString'] === id) {
					hasAccount = true;
				}
			});
		}
		return hasAccount;
	}

	onRowAccountChange(event) {
		console.log('ROW ACCOUNT CHANGE', event);
		if (event.data && event.data.length > 0) {
			const rowAccount = event.data[0];
			if (this.rowAccount['ilcValid']) {
				console.log('ROW ACCOUNT ILC VALID WAS VALID');
				rowAccount.ilcValid = event.ilcValid ? true : false;
			}
			if (event.ilcClick) {
				rowAccount.ilcValid = true;
			}
			console.log('ROW ACCOUNT ILC VALID', rowAccount.ilcValid);
			this.rowAccount = rowAccount;
			this.updateAllAccounts(false);

			if (event.data.length > 1) {
				event.data.slice(1).forEach(acct => {
					const rowAcct = {
						accountid: acct.accountid,
						activitycode: acct.activitycode,
						activitydescription: acct.activitydescription,
						workitemid: acct.workitemid,
						workitemdescription: acct.workitemdescription,
						billcode: acct.billcode,
						groupid: acct.groupid,
						ilcValid: true
					};
					this.timesheetService.addRow(false, rowAcct);
				});
			}
		}
		this.checkValidRows();
		setTimeout(() => {
			this.timesheetService.calculateTotal();
		}, 50);
	}

	onRowTypeChange(event) {
		console.log('ROW TYPE CHANGE', event);
		this.rowType = event.data;
		this.canEditCustomType = this.configService.canEditCustomTimesheetLineItem(this.rowType);
		this.updateAllAccounts();
	}

	/*
	Updates accounts, key, & type for all hour objects to stay in sync with selected UI elements
	*/
	updateAllAccounts(validate = true) {
		console.log('UPDATE ALL ACCOUNTS', this.rowAccount, this.rowType);
		const self = this;
		if (self.accountService.isDefaultOption(self.rowAccount['accountid'])) {
			this.hours.forEach(function (d, i) {
				d.account = self.rowAccount;
				d.key = self.rowAccount['accountid'];
				d.type = self.rowAccount['accountid'];
			});
		} else {
			this.hours.forEach(function (d, i) {
				d.account = self.rowAccount;
				d.key = self.rowAccount['accountid'];
				d.type = self.rowType;
			});
		}
		if (validate) {
			this.checkValidRows();
		}
	}

	/*
	Updates the displayed work item when the account selection is changed
	*/
	updateWorkItem(options) {
		// options will be null when default time type is selected
		// if not null, update work item display
		// if null set children values to empty strings to avoid confusion
		// children are ignored if default time type but best to clear
		if (options !== null) {
			this.rowAccount['workitemid'] = options[0];
			this.updateActivityCode(this.accountService.getActivitycodeOptions(this.rowAccount['accountid'], this.rowAccount['workitemid']));
		} else {
			this.rowAccount['workitemid'] = '';
			this.rowAccount['activitycode'] = '';
			this.rowAccount['billcode'] = '';
			this.rowType = '';
		}
		// update accounts for all hour objects to stay in sync with updated row account
		this.updateAllAccounts();
		console.log('UPDATE WORK ITEM', this.rowAccount);
	}

	/*
	Updates the displayed activity code when the work item selection is changed
	*/
	updateActivityCode(options) {
		this.rowAccount['activitycode'] = options[0];
		this.updateBillCode(this.accountService.getBillcodeOptions(this.rowAccount['accountid'], this.rowAccount['workitemid'], this.rowAccount['activitycode']));
		this.checkValidRows();
	}

	/*
	Updates the displayed bill code when the activity code selection is changed
	*/
	updateBillCode(options) {
		this.rowAccount['billcode'] = options[0];
		this.checkValidRows();
	}

	allowTimeEdit() {
		return this.timesheetService.allowTimeEdit(this.correctRow);
	}

	allowSTOTEdit() {

		const isOriginalRow = this.rowIndex <= this.dataService.timesheetRows.length - 1;
		const isCorrectRow = this.correctRow;

		let allowSTOTEdit = this.allowTimeEdit();

		if (isCorrectRow
			&& isOriginalRow) {

			allowSTOTEdit = false;
		}

		return allowSTOTEdit;
	}

	allowAccountEdit() {

		const isNewRow = this.rowIndex > this.dataService.timesheetRows.length - 1;

		const canEdit = this.configService.canDo(this.configService.getDataObj(this.configService.timesheetDataObj).fields, this.configService.timeentryProp, 'edit');

		const canCustom = this.configService.canEditCustomTimesheetLineItem(this.rowType);

		const isSaved = this.dataService.getTimesheetStatus() === this.configService.timesheetSaveStatus;

		const isCorrectRow = this.correctRow;

		const hoursLocked = this.dataService.isTimesheetHoursLock();

		const isReconciled = this.dataService.isTimesheetCRR();

		const isLocked = this.dataService.getTimeLock();

		const isRejected = this.dataService.getTimesheetStatusDescription() === this.configService.timesheetRejectedStatus;

		let allowAccountEdit = false;

		if (!isCorrectRow) {
			if (!isLocked && !canCustom && canEdit && isSaved && !isRejected) {
				allowAccountEdit = true;
			}
		} else {
			if (!canCustom && canEdit && isNewRow && isSaved && !isRejected) {
				allowAccountEdit = true;
			}
			if (hoursLocked && isReconciled) {
				allowAccountEdit = false;
			}
		}
		return allowAccountEdit;
	}

	isValid() {
		let isValid = true;
		if (this.correctRow) {
			if (!this.timesheetService.rowsCorrectUniqueness[this.rowIndex] ||
				!this.timesheetService.rowsCorrectILCValidity[this.rowIndex] ||
				!this.timesheetService.correctRowsZeroValidity[this.rowIndex]) {
				isValid = false;
			}
		} else {
			if (!this.timesheetService.rowsUniqueness[this.rowIndex] ||
				!this.timesheetService.rowsILCValidity[this.rowIndex] ||
				!this.timesheetService.rowsZeroValidity[this.rowIndex]) {
				isValid = false;
			}
		}
		return isValid;
	}

	totalHours(hours) {
		let total = 0;
		const hoursCalc = _.cloneDeep(hours);
		hoursCalc.forEach(hour => {
			if (!hour.value) {
				hour.value = 0;
			}
			total += hour.value;
		});
		return total.toFixed(1);
	}

	canDeleteRow(isCorrection, timesheetStatus, rowIndex) {
		let canDelete = false;
		// can always delete new correction row
		if (isCorrection && this.hours['newRow']) {
			canDelete = true;
		} else {
			canDelete = this.timesheetService.canDeleteRow(isCorrection, timesheetStatus, rowIndex) && this.allowTimeEdit();
		}
		return canDelete;
	}
}
